import { render, staticRenderFns } from "./VolunteerHome.vue?vue&type=template&id=6b982690&scoped=true"
import script from "./VolunteerHome.vue?vue&type=script&lang=js"
export * from "./VolunteerHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b982690",
  null
  
)

export default component.exports